import {AuthenticatedAPI, HttpRequestService} from '@wiggot/core-apis'
const domain = process.env.GOOGLE_PLACES_API_URL ?? ''

class BaseAPI extends AuthenticatedAPI {
  constructor() {
    super({
      domain
    })
  }
}

export const googleMasApi = new HttpRequestService(new BaseAPI())
